import { createSelector } from 'reselect';
import { RootState } from '../reducers';

export const selectContractDetails = createSelector(
  (state: RootState) => state.contracts,
  (contract) => ({
    contracts: contract.contractList,
    selectedContractDetails: contract.contractDetail,
    transactionFeeMetrics: contract.transactionFeeMetrics,
    contractServices: contract.contractServices,
    doctorSettings: contract.doctorSettings,
    status: contract.status
  })
);

